export default function shareLinks() {
  const nodelist = document.querySelectorAll('.js-share');
  const elements = Array.prototype.slice.call(nodelist,0);

  const handleSharePopup = (e) => {
    e.preventDefault();

    console.log(e.currentTarget.href);

    const url = e.currentTarget.href;
    const name = "sharePopup";

    const wTop = window.screenTop ? window.screenTop : window.screenY;
    const wLeft = window.screenLeft ? window.screenLeft : window.screenX;

    const options = {
      width: 500,
      height: 500,
      top: wTop + window.innerHeight / 2 - 500 / 2,
      left: wLeft + window.innerWidth / 2 - 500 / 2,
      scrollbars: false,
      toolbar: false,
      location: false,
      titlebar: false,
      directories: false,
      resizable: true,
      status: false,
      menubar: false,
      noreferrer: false,
    };

    const params = Object.entries(options)
      .map(([key, value]) => `${key}=${value}`)
      .join(',');

    return window.open(url, name, params);
  }

  elements.forEach(function(link) {
    link.addEventListener('click',handleSharePopup);
  });
}

shareLinks();
